// extracted by mini-css-extract-plugin
module.exports = {"body":"body--3FUNJ","pic":"pic--31hou"};